import { Controller, useFormContext } from "react-hook-form";

import { Checkbox } from "@smart/itops-sb-design-system-dom";

type AreasToAffectProps = {
  disabled?: boolean;
};

export const AreasToAffect = ({ disabled }: AreasToAffectProps) => {
  const { control } = useFormContext();

  return (
    <div className="flex flex-col gap-small">
      <div className="text-paragraph font-semibold">Areas to Affect</div>
      <Controller
        control={control}
        name="affectedAreas.headerBackground"
        render={({ field, fieldState }) => (
          <Checkbox
            label="Header Background"
            checked={field.value}
            onChange={(checked) => field.onChange(checked)}
            error={!!fieldState.error?.message}
            disabled={disabled}
          />
        )}
      />
      <Controller
        control={control}
        name="affectedAreas.headerUnderline"
        render={({ field, fieldState }) => (
          <Checkbox
            label="Header Underline"
            checked={field.value}
            onChange={(checked) => field.onChange(checked)}
            error={!!fieldState.error?.message}
            disabled={disabled}
          />
        )}
      />
      <Controller
        control={control}
        name="affectedAreas.sectionTabHighlights"
        render={({ field, fieldState }) => (
          <Checkbox
            label="Section Tab Highlights"
            checked={field.value}
            onChange={(checked) => field.onChange(checked)}
            error={!!fieldState.error?.message}
            disabled={disabled}
          />
        )}
      />
      <Controller
        control={control}
        name="affectedAreas.buttons"
        render={({ field, fieldState }) => (
          <Checkbox
            label="Buttons"
            checked={field.value}
            onChange={(checked) => field.onChange(checked)}
            error={!!fieldState.error?.message}
            disabled={disabled}
          />
        )}
      />
    </div>
  );
};
